<template>
	<section class="card-wrapper featured-cases">
		<div class="container">
			<div class="row">
				<div ref="cardWrapper"
					 class="col-xs-12">
					<div class="card-container">
						<baseFeaturedCase v-for="work in works"
										  :key="work.id"
										  :data="work"
										  class="card-wrapper" />

					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
const props = defineProps({
	data: {
		type: Object,
		required: true,
	},
	sizes: {
		type: String,
		required: false,
		default: null
	},
})

const { gsap } = useGsap()
const mediaQuery = gsap.matchMedia()
const cardWrapperRef = useTemplateRef('cardWrapper')

const triggers = {}
let $q

const works = computed(() => props.data?.item?.featured_cases || [])

function animRevealCases() {
	const cards = $q('.card')

	cards.forEach((card, i) => {
		mediaQuery.add('(min-width: 768px)', () => {
			triggers[`scrollSpeed${i}`] = gsap
				.timeline({
					scrollTrigger: {
						id: `scrollSpeedFeaturedCard${i}`,
						trigger: card,
						start: 'top bottom',
						end: 'center top',
						scrub: 0.5,
					}
				})
				.fromTo(card, {
					yPercent: -10 * (i % 2),
				}, {
					yPercent: () => -30 * (i % 2),
					// ease: 'power1.inOut'
				}, 0)
		})

		triggers[`revealFeatured${i}`] = gsap.timeline({
			scrollTrigger: {
				id: `revealFeaturedCard${i}`,
				trigger: card,
				start: 'top bottom',
			}
		})
			.to(card, {
				autoAlpha: 1,
				duration: 1.5,
				ease: 'circ.out'
			})
			.from(card, {
				y: 100,
				duration: 2,
				ease: 'expo.out'
			}, '<')
			.to($q('.card-title'), {
				'--font-width': 400,
				duration: 3,
				ease: 'expo.out'
			}, '<')


	})
}

function initFeaturedCases() {
	$q = gsap.utils.selector(cardWrapperRef.value)
	animRevealCases()
}

onMounted(() => {
	useAnims(initFeaturedCases, triggers)
})
</script>

<style lang="scss" scoped>
.card-container {
	display: flex;
	flex-flow: row wrap;
	align-items: flex-start;
	gap: 45px;
	// display: grid;
	// grid-template-columns: 1fr;

	// @include for-devices-above(md) {
	// grid-template-columns: repeat(2, 1fr);
	// gap: rem-calc(120 45);
	// }

	.card-wrapper {
		width: 100%;

		@include for-devices-above(md) {
			width: calc(50% - 22.5px);
		}
	}
}
</style>
